import React, { useContext } from "react";

import { QuestionCardOnTheTable, ActivationCelebration } from "..";
import { TeamContext } from "../../../context";
import { useBoardDisplayView } from "../../../hooks";
import { Phase } from "../../../util/enums";

const ChallengeCardOnTheTable = () => {
    const { game } = useContext(TeamContext);
    const [challengeCard, displayView ] = useBoardDisplayView();
    const dilemmaOwnerImage = `${process.env.REACT_APP_BACKEND_URL}${game?.players.find( (item: any) => item.email === game.gameInfo.currentPlayerEmail)?.image}` || "";

    const renderDisplayView = () => {
    
        if(displayView === 'teamCelebration')
            return ( <ActivationCelebration/> );
        
        if (displayView === "question" && game?.phase === Phase.QUESTION_CARD)
            return (<QuestionCardOnTheTable challengeCard={challengeCard} dilemmaOwnerImage={dilemmaOwnerImage} /> );

        if (displayView === "initial")
            return (<div></div>);
    }

    return (
        <React.Fragment>
            {renderDisplayView()}
        </React.Fragment>
    )


}

export default ChallengeCardOnTheTable;